export default {
  live: 'live',
  before: 'before',
  after: 'after'
}
